import type { CustomerDetailsTitleInput } from '@makemydeal/dr-sales-checkin-types';

import { CUSTOMER_DETAILS_LABELS } from './constants';

export const buildCustomerDetailsTitle = ({
    buyerFirstName,
    legalName,
    isBusinessBuyer,
    coBuyerFirstName
}: CustomerDetailsTitleInput): string =>
    CUSTOMER_DETAILS_LABELS.title(isBusinessBuyer ? legalName : buyerFirstName, coBuyerFirstName);
